export const getCustomers = (state) => state.customers.customers;
